'use client'

import { useTranslations } from 'next-intl'
import { use } from 'react'

import SeeAllLink from '@/app/[locale]/(worlds)/components/SeeAllLink'
import Swimlane, { SwimlaneSkeleton } from '@/app/[locale]/(worlds)/components/Swimlane'
import { SWIMLANE_DEFAULT_CONTENT_INSET_CLASS } from '@/constants/swimlane'
import { isSavedWorldAvailable, PaginatedResponse, Room, SavedWorldEntry } from '@/services/cms'

type SavedRowProps = {
  savedPromise: Promise<PaginatedResponse<SavedWorldEntry> | null>
}

export default function SavedRow({ savedPromise }: SavedRowProps) {
  const t = useTranslations()
  const data = use(savedPromise)

  if (!data || data.pages?.total === 0 || data.results.length === 0) {
    return null
  }

  const availableRooms = data.results.filter(isSavedWorldAvailable) as Room[]
  if (availableRooms.length === 0) return null

  return (
    <Swimlane
      data-section="saved-row"
      title={t('worlds-landing.saved-row.title')}
      titleAction={<SeeAllLink href="/saved" label={t('worlds-landing.common.see-all')} />}
      cardVariant="viverse"
      rooms={availableRooms}
      dataRoomIdPrefix="saved"
      cardClassName="h-[169px] max-w-[200px] min-w-[200px] flex-none"
      scrollClassName="no-scrollbar flex w-full flex-1 gap-2 overflow-x-auto select-none md:gap-4 -mb-8 pt-2 pb-10"
      contentInsetClassName={SWIMLANE_DEFAULT_CONTENT_INSET_CLASS}
      hidePremiumBadge={false}
    />
  )
}

export function SavedRowSkeleton() {
  return <SwimlaneSkeleton showTitleAction />
}
